// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"d54c2d5d","922":"0036bcdb"}[chunkId] + ".chunk.js";
};